import Vue from "vue";
import { VueTreeList, Tree, TreeNode } from 'vue-tree-list-v2';

Vue.component("entities-treeview-search-result", {
    props: ["data"],
    computed: {
        treeData: function () {
            return new Tree(this.data);
		},
		coverageExclusionTooltipLabel: function () {
			return window.labels.coverageExclusionTooltip;
		}
    },
    methods: {
        onClick(params) {
            console.log(params);
        }
	},
    template: `
		<vue-tree-list
			:model="treeData"
			@click="onClick"
			v-bind:default-expanded="false">
			<template v-slot:leafNameDisplay="props">
				<div class="entity-row" :id="'entity_' + props.model.id">
					<i v-if="props.model.excluded" class="fas fa-ban mt-2 pr-2 has-text-danger" :title="coverageExclusionTooltipLabel"></i>
					<div v-if="props.model.referenceNumber != null && props.model.referenceNumber != undefined && props.model.referenceNumber != ''" class="entity-row-reference-number pr-2">{{ props.model.referenceNumber }}</div>
					<div class="entity-row-display-name" v-html="props.model.name"></div>					
				</div>				
			</template>
			<template v-slot:treeNodeIcon="props">
				<span class="icon">
					<i v-if="props.model.children && props.model.children.length > 0 && !props.model.isNote" class="fa fa-sitemap"></i>
					<i v-else-if="props.model.showNoteIcon" class="fa fa-comment has-text-info"></i>
					<i v-else class="fa fa-fw"></i>					
				</span>
			</template>
		</vue-tree-list>
	`
});